import { Suspense, useCallback, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PageLoading from '@/business-components/page-loading';
import routes, { RouteProps } from '@/config/routes';
import NotMatch from './pages/404';
import '@/styles/index.scss';

const SubRoute: React.FC<RouteProps> = ({ routes: subRoutes, path, ...subRoute }) => {
  const scrollToTop = useCallback(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.addEventListener('focusout', scrollToTop);
    return () => window.removeEventListener('focusout', scrollToTop);
  }, [scrollToTop]);

  if (!subRoutes) {
    return <subRoute.component />;
  }

  return (
    <>
      <subRoute.component />
      <Switch>
        {subRoutes.map(route => (
          <Route key={route.path} path={route.path} exact={route.exact}>
            <SubRoute {...route} />
          </Route>
        ))}
      </Switch>
    </>
  );
};

function App() {
  return (
    <Router>
      <Suspense fallback={<PageLoading loading />}>
        <Switch>
          {routes.map(route => (
            <Route key={route.path} path={route.path} exact={route.exact}>
              <SubRoute {...route} />
            </Route>
          ))}
          <Route path="*">
            <NotMatch />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
